// Reply times on the FAQ step's buttons: "Chat with us" (chat_reply_minutes)
// vs "Still raise an issue" (the sub-category's ticket SLA, comm_sla_minutes),
// both from the categories API. Rounded up, so the promise is never shorter
// than the real SLA. null = no number to show.
export const formatReplyTime = (minutes?: number | null): string | null => {
  if (!minutes || !(minutes > 0)) {
    return null;
  }
  if (minutes < 60) {
    return `${Math.ceil(minutes)} min`;
  }
  if (minutes < 1440) {
    const hrs = Math.ceil(minutes / 60);
    return `${hrs} ${hrs === 1 ? 'hr' : 'hrs'}`;
  }
  const days = Math.ceil(minutes / 1440);
  return `${days} ${days === 1 ? 'day' : 'days'}`;
};
